<template>
  <!-- 我的发票 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      个人中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">发票</span>
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in selectArr"
          :key="index"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item.id)"
        >
          {{ item.name }}
        </p>
      </div>
      <!-- 1开具发票时显示 可开发票金额 历史已开具金额.. -->
      <div class="openable" v-if="select == 1">
        <div class="openable-left">
          <p class="GrossAmount">{{ ItCanBeOpened.invoicableAmount }}元</p>
          <p class="Tips">可开发票金额</p>
        </div>
        <div class="openable-left">
          <p class="GrossAmount">
            <span>{{ ItCanBeOpened.invoicedAmount }}元</span>
          </p>
          <p class="Tips">历史已开具金额</p>
        </div>
      </div>
      <!-- 1开具发票时显示 单选 可开票 不可开票 -->
      <div class="single-choice" v-if="select == 1">
        <div
          class="single-choice-box"
          v-for="(item, index) in radioList"
          :key="index"
        >
          <div
            :class="item.id == radio ? 'Select-box' : 'notSelect-box'"
            @click="handelSingleChoice(item)"
          ></div>
          <p>{{ item.name }}</p>
        </div>
      </div>
      <!-- 2 单选 -->
      <div class="single-choice" v-if="select == 2">
        <div
          class="single-choice-box"
          v-for="(item, index) in radioList1"
          :key="index"
        >
          <div
            :class="item.id == radio ? 'Select-box' : 'notSelect-box'"
            @click="handelSingleChoice(item)"
          ></div>
          <p>{{ item.name }}</p>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="screen" v-if="select == 1">
        <p>订单ID：</p>
        <!-- 订单ID输入框 -->
        <div class="size-search">
          <el-input v-model="input" placeholder="请输入"></el-input>
        </div>
        <p class="user-Id">时间：</p>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          unlink-panels
          clearable
          @clear="value1 = null"
        >
        </el-date-picker>
        <p class="ser-btn public-style" @click="handelSearch">搜 索</p>
        <p class="heavy-btn public-style" @click="handelReset">重 置</p>
      </div>
      <!-- 搜索 -->
      <div class="screen" v-if="select == 2">
        <p>订单ID：</p>
        <!-- 订单ID输入框 -->
        <div class="size-search">
          <el-input v-model="OrderData" placeholder="请输入"></el-input>
        </div>
        <p class="user-Id">开票抬头：</p>
        <!-- 开票主体下拉选择 -->
        <div class="size-search">
          <el-input v-model="value" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="screen" v-if="select == 2">
        <p>发票号：</p>
        <div class="size-search">
          <el-input v-model="input1" placeholder="请输入"></el-input>
        </div>
        <p class="user-Id">时间：</p>
        <el-date-picker
          v-model="Time"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          unlink-panels
          clearable
          @clear="Time = null"
        >
        </el-date-picker>
        <p class="ser-btn public-style" @click="handelSearch">搜 索</p>
        <p class="heavy-btn public-style" @click="handelReset">重 置</p>
      </div>
      <!-- 批量开发票 -->
      <div class="BulkBilling" v-if="select == 1">
        <p>
          已选择{{ SelectedSet.length }}个订单，共代开金额：<span
            style="color: #fe574a"
            >{{ TotalAmount }}元</span
          >
        </p>
        <div class="ButtonArea">
          <p class="firm-clickable" @click="handelClick">批量开具发票</p>
        </div>
      </div>
      <!-- 表格 -->
      <div class="tabulation">
        <tableInvoice
          v-if="select == '1'"
          :tableData="tableData"
          :ClearSel="ClearSel"
          :RealName="RealName"
          @handleSelectionChange="handleSelectionChange"
          @Refresh="Refresh"
        ></tableInvoice>
        <tableIntwe
          v-if="select == '2'"
          :tableData="tableData1"
          :RealName="RealName"
          @Refresh="Refresh"
        ></tableIntwe>
        <ModuleThree
          :dataMsg="dataMsg"
          v-if="select == '3'"
          @Refresh="Refresh"
        ></ModuleThree>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box" v-if="select == '1' || select == '2'">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
    <!-- 代开发票弹窗 -->
    <ticketDialog
      :dialogVisible="dialogVisible"
      :acquiesce="acquiesce"
      :headList="dataMsg.headList"
      :mailList="dataMsg.mailList"
      :addressList="dataMsg.addressList"
      @handleCloseDele="handleCloseDele"
      @handleUnderstand="handleUnderstand"
    ></ticketDialog>
  </div>
</template>

<script>
// 引入接口
import {
  queryInvoiceCount, //查看发票统计（可开/已开金额）
  listCompanyInvoiceIssue, // 我的发票开票列表
  listInvoiceAuditRecord, // 开票记录
  getInvoiceHeadAndMailInfo, //查看发票相关信息，发票抬头，邮寄地址，电子邮箱地址
  getInvoiceHeadSelect, // 获取所属发票抬头列表c
  getDefaultHeadAndMailInfo, // 代开发票获取默认抬头与地址邮箱
  batchIssueInvoice, // 批量开票
} from "../../../../../assets/api/CenterInvoice";
import {
  postGetIdentityAuditInfo, //个人中心-身份验证-身份认证/支付密码信息页面查询 (用于获取 是否实名认证)
} from "../../../../../assets/api/index";
// 引入代开发票 表格组件
import tableInvoice from "./components/tableInvoice.vue";
// 引入开票记录 表格组件
import tableIntwe from "./components/tableIntwe.vue";
// 引入发票信息管理 组件
import ModuleThree from "./components/ModuleThree.vue";
// 引入代开发票弹窗 组件
import ticketDialog from "./components/ticketDialog.vue";
// 引入分页组件
import paging from "../../../../../components/paging.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      tableData: [], // 表格数据
      tableData1: [], // 表格数据2
      dataMsg: {}, // 发票信息管理 列表数据
      selectArr: [
        { name: "开具发票", id: "1" },
        { name: "开票记录", id: "2" },
        { name: "发票信息管理", id: "3" },
      ], // 切换 代开发票  开票记录 发票信息管理
      select: "1", // 筛选
      radioList: [
        { name: "可开发票", id: "" },
        // { name: "暂不可开票", id: "2" },
      ], // 选择可开发票 暂不可开票
      radioList1: [
        { name: "全部", id: "" },
        { name: "成功", id: "1" },
        { name: "失败", id: "2" },
        { name: "正在审核", id: "0" },
        { name: "作废", id: "3" },
      ], // 选择可开发票 暂不可开票
      radio: "", // 单选
      value: "", // 开票主体
      value1: null, //时间 1
      Time: null, //时间2
      OrderData: "", //订单id2
      input: "", //订单id 1
      input1: "", // 发票号
      options: [], // 搜索下拉框数据
      dialogVisible: false, // 开票弹窗
      ItCanBeOpened: {}, // 可开金额，历史已开金额
      SelectedSet: [], // 表格1的选中数据 数组集合
      TotalAmount: "0", // 表格1的选中总金额
      acquiesce: {}, // 设置的默认
      ClearSel: 0, // 传给表格1 操作后清空已选
      RealName: false, //是否实名认证
    };
  },
  components: {
    paging,
    tableInvoice,
    ticketDialog,
    tableIntwe,
    ModuleThree,
  },
  created() {
    // 查看发票统计(可开/已开金额)
    this.queryInvoiceCount();
    // 我的发票开票列表
    this.listCompanyInvoiceIssue();
    // 获取所属发票抬头列表 接口
    this.getInvoiceHeadSelect();
    // 调用接口获取是否实名认证
    this.postGetIdentityAuditInfo();
  },
  methods: {
    // 调用接口获取是否实名认证
    postGetIdentityAuditInfo() {
      postGetIdentityAuditInfo().then((res) => {
        if (res.data.status == 3) {
          this.RealName = true;
        }
      });
    },
    // 操作完成刷新数据
    Refresh() {
      setTimeout(() => {
        if (this.select == 1 || this.select == "1") {
          this.listCompanyInvoiceIssue();
          this.queryInvoiceCount();
          this.ClearSel++;
          this.SelectedSet = [];
          this.TotalAmount = 0;
        } else if (this.select == 2 || this.select == "2") {
          this.listInvoiceAuditRecord();
        } else if (this.select == 3 || this.select == "3") {
          this.getInvoiceHeadAndMailInfo();
        }
      }, 100);
    },

    // 搜索
    handelSearch() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      if (this.select == 1) {
        // 代开发票
        this.listCompanyInvoiceIssue();
      } else if (this.select == 2) {
        this.listInvoiceAuditRecord();
      }
    },
    // 重置
    handelReset() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      if (this.select == 1) {
        this.value1 = null; //时间
        this.input = ""; //订单id
        // 代开发票
        this.listCompanyInvoiceIssue();
      } else if (this.select == 2) {
        this.value = ""; // 开票主体
        this.input1 = ""; // 发票号
        this.Time = null;
        this.OrderData = "";
        this.listInvoiceAuditRecord();
      }
    },

    // 查看发票统计（可开/已开金额）接口
    async queryInvoiceCount() {
      var data = {
        data: {
          ownerType: 0, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getUser.id, //开票主体id
        },
      };
      const res = await queryInvoiceCount(data);
      this.ItCanBeOpened = res.data;
    },

    // 我的发票开票列表 接口
    async listCompanyInvoiceIssue() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          ownerType: 0, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getUser.id, //开票主体id
          orderNumber: this.input, // 订单id查询
          startTime: time, // 搜索/筛选传的 开始时间
          endTime: timeEnd, // 搜索/筛选传的 结束时间
        },
      };
      const res = await listCompanyInvoiceIssue(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      this.tableData = res.data.list;
      this.pagingObj.totalDevice = res.data.total;
    },
    // 我的发票列表多选 数据及金额总和
    handleSelectionChange(num, val) {
      this.SelectedSet = val;
      this.TotalAmount = num;
    },

    // 开票记录
    async listInvoiceAuditRecord() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.Time;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          ownerType: 0, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getUser.id, //开票主体id
          orderNum: this.OrderData, // 订单id查询
          startTime: time, // 搜索/筛选传的 开始时间
          endTime: timeEnd, // 搜索/筛选传的 结束时间
          status: this.radio, // 发票审批状态
          num: this.input1, // 发票号
          headName: this.value, //发票抬头
        },
      };
      const res = await listInvoiceAuditRecord(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      this.tableData1 = res.data.list;
      this.pagingObj.totalDevice = res.data.total;
    },

    // 发票信息管理
    async getInvoiceHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 0, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getUser.id, //开票主体id
        },
      };
      const res = await getInvoiceHeadAndMailInfo(data);
      this.dataMsg = res.data;
    },

    // 获取所属发票抬头列表 接口
    async getInvoiceHeadSelect() {
      var data = {
        data: {
          ownerType: 0, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getUser.id, //开票主体id
        },
      };
      const res = await getInvoiceHeadSelect(data);
      this.options = res.data;
    },

    //获取默认的地址/邮箱/抬头 接口
    async getDefaultHeadAndMailInfo() {
      var data = {
        data: {
          ownerType: 0, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getUser.id, //开票主体id
        },
      };
      // 获取默认的地址/邮箱/抬头 接口
      const res1 = await getDefaultHeadAndMailInfo(data);
      this.acquiesce = res1.data;
    },
    //单选
    handelSingleChoice(item) {
      console.log("55555");
      this.radio = item.id;
      this.listInvoiceAuditRecord();
    },
    // 点击批量开票
    handelClick() {
      if (this.SelectedSet.length > 0) {
        if (this.RealName) {
          this.getDefaultHeadAndMailInfo();
          this.getInvoiceHeadAndMailInfo();
          setTimeout(() => {
            this.dialogVisible = true;
          }, 100);
        } else {
          this.$tool.PromptBox("warning", "请先在身份验证中进行实名认证！");
        }
      } else {
        this.$tool.PromptBox("warning", "请选择一条数据！");
      }
    },
    //关闭弹窗
    handleCloseDele() {
      this.dialogVisible = false;
    },
    // 弹窗确认
    handleUnderstand(val, unlockConfirm) {
      const unlock =
        typeof unlockConfirm === "function" ? unlockConfirm : null;
      // 获取 选择消费记录的id集合
      var arr = [];
      var k = 0;
      for (var i in this.SelectedSet) {
        arr[k++] = this.SelectedSet[i].id;
      }

      // 调用批量开票接口
      var data = {
        data: {
          ownerType: 0, //开票主体类型 个人0 企业1
          ownerId: this.$store.getters.getUser.id, //开票主体id
          recordIdList: arr, // 消费记录id
          type: val.listArrSelect, //0电子1纸质
          headId: val.value, //抬头id
          attribute: val.listArrSelect1, //0普通增值税发票1专用
          mailOrAddressId: val.listArrSelect == 0 ? val.value1 : val.value2, //邮箱/地址
        },
      };
      batchIssueInvoice(data)
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.ClearSel++;
            this.SelectedSet = [];
            this.TotalAmount = 0;
            this.dialogVisible = false;
            this.listCompanyInvoiceIssue();
            this.queryInvoiceCount();
          }
        })
        .finally(() => {
          unlock && unlock();
        });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      if (this.select == 1) {
        // 调用代开发票列表接口s
        this.listCompanyInvoiceIssue();
      } else if (this.select == 2) {
        this.listInvoiceAuditRecord();
      } else if (this.select == 3) {
        this.getInvoiceHeadAndMailInfo();
      }
    },

    // 筛选
    handelSelect(num) {
      this.radio = "";
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
      if (num == 1) {
        // 切换到代开发票 调用代开发票列表接口
        this.listCompanyInvoiceIssue();
      } else if (num == 2) {
        // 调用开票记录接口
        this.listInvoiceAuditRecord();
      } else if (num == 3) {
        this.getInvoiceHeadAndMailInfo();
      }
      this.select = num;
      // this.$emit("handelSelect", num);
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px !important;
  line-height: 35px !important;
  padding: 0 8px !important;
}
/deep/.el-icon-date {
  font-size: 18px !important;
  margin-left: 0 !important;
}
/deep/.el-range__close-icon {
  line-height: 35px;
  width: 25px;
}

.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    margin-top: 13px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    // 切换
    .Toggle {
      width: 100%;
      height: 30px;
      display: flex;
      color: #333333;
      text-align: center;
      font-weight: 400;
      p:nth-child(1) {
        margin-left: 20px;
      }
      p {
        margin-right: 40px;
        font-size: 16px;
        cursor: pointer;
      }
      .select-p {
        color: #409eff ;
        box-sizing: border-box;
        border-bottom: 2px solid #409eff ;
      }
    }
    // 1开具发票  可开金额
    .openable {
      // width: 400px;
      min-width: 400px;
      margin-top: 30px;
      margin-right: auto;
      height: 70px;
      border: 1px solid #409eff ;
      border-radius: 5px;
      display: flex;
      .openable-left {
        min-width: 200px;
        height: 100%;
        p {
          height: 35px;
          line-height: 35px;
          text-align: center;
          font-weight: 400;
          font-family: PingFangSC-Medium;
        }
        .GrossAmount {
          font-size: 18px;
          color: #fe574a;
        }
        .Tips {
          font-size: 18px;
          color: #409eff ;
        }
        .details-p {
          font-size: 14px;
          color: #666666;
          font-weight: 400;
          span {
            color: #333333;
          }
        }
      }
    }
    // 1 单选
    .single-choice {
      width: 100%;
      height: 18px;
      line-height: 18px;
      margin-top: 30px;
      display: flex;
      .single-choice-box {
        display: flex;
        .notSelect-box {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background-image: url("../../../../../assets/imgs/weigouxuan@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
        .Select-box {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background-image: url("../../../../../assets/imgs/gouxuan@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          margin-right: 30px;
          margin-left: 10px;
        }
      }
    }
    // 搜索
    .screen {
      width: 100%;
      height: 35px;
      line-height: 35px;
      margin-top: 30px;
      display: flex;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      display: flex;
      position: relative;
      .Back {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 0px;
        top: 10px;
      }
      .user-Id {
        margin-left: 30px;
      }
      .public-style {
        width: 75px;
        height: 35px;
        text-align: center;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        font-weight: 400;
        box-sizing: border-box;
        border: 1px solid #409eff ;
        cursor: pointer;
      }
      .ser-btn {
        background: #409eff ;
        color: #ffffff;
        margin-left: 30px;
        margin-right: 10px;
      }
      .heavy-btn {
        background: #ffffff;
        color: #409eff ;
      }
      .size-search {
        width: 120px;
        height: 30px;
        font-size: 14px;
        /deep/.el-input__inner {
          height: 35px !important;
          border: 1px solid #409eff ;
        }
      }
    }
    // 批量开票
    .BulkBilling {
      width: 100%;
      height: 35px;
      line-height: 35px;
      display: flex;
      margin-top: 28px;
      font-weight: 400;
      p {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333333;
      }
      .ButtonArea {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        p {
          width: 120px;
          height: 35px;
          background: #409eff ;
          border-radius: 5px;
          color: #ffffff;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    // 表格
    .tabulation {
      width: 100%;
      min-height: 400px;
      box-sizing: border-box;
      margin-top: 30px;
    }
    // 分页
    .paging-box {
      width: 100%;
      height: 22px;
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      .paging {
        width: 90%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
